import { ref, computed, nextTick } from 'vue';
import { useStore } from '@/utils/vue-api';

export function useBrandHeader() {
	const store = useStore();

	// ---------------------------------- Background

	const mixBackground = ref(null);
	const mixLogo = ref(null);

	const getIrThemeColor = computed(() => store.getters.getIrThemeColor);
	const getIrBaseInfo = computed(() => store.getters.getIrBaseInfo);
	const getLogo = computed(() => getIrBaseInfo.value?.logo);

	const callbackMix = logo => {
		let colorValue = getIrThemeColor.value;
		colorValue = colorValue.toLocaleUpperCase();
		mixBackground.value?.setMixBgAndColor(logo, colorValue);
	};
	const renderLogoWithColor = callback => {
		const { logo } = getIrBaseInfo.value;
		if (!logo) return;

		nextTick(() => {
			if (callback) {
				callback(logo);
			} else {
				mixLogo.value.drawLogo(logo).then(() => {
					callbackMix(logo);
				});
			}
		});
	};

	const baseBackground = ref(null);
	const updateBackground = image => {
		baseBackground.value = image || null;
	};

	// ---------------------------------- Content

	const getIrMarketAndCode = computed(() => store.getters.getIrMarketAndCode);
	const getIrName = computed(() => store.getters.getIrName);
	const getIrSlogan = computed(() => store.getters.getIrSlogan);
	const getIrIndustryName = computed(() => store.getters.getIrIndustryName);

	const getUpperMarketAndCode = computed(() => {
		const [market, code] = getIrMarketAndCode.value;
		if (!code) return '';
		return `${code}.${market.toLocaleUpperCase()}`;
	});

	const composeInfoAbout = computed(() => {
		let info = [];
		if (getUpperMarketAndCode.value) info.push(getUpperMarketAndCode.value);
		if (getIrIndustryName.value) info.push(getIrIndustryName.value);
		return info;
	});

	const formatIrName = computed(() => getIrName.value);
	const formatIrSlogan = computed(() => `“${getIrSlogan.value}”`);

	return {
		mixBackground,
		mixLogo,
		baseBackground,
		getLogo,
		updateBackground,
		callbackMix,
		renderLogoWithColor,

		getIrSlogan,
		composeInfoAbout,
		formatIrName,
		formatIrSlogan
	};
}
